exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview .thumbnail[data-v-442ab829]{border-top-left-radius:unset;border-top-right-radius:unset;height:auto;text-align:center}.asset-preview .thumbnail img[data-v-442ab829]{max-height:198px;position:static;margin:0}.asset-preview .thumbnail img.qr-code[data-v-442ab829]{max-height:100px}", ""]);

// exports
